import { render, staticRenderFns } from "./DomainCreate.vue?vue&type=template&id=5cf9d81b&scoped=true&"
import script from "./DomainCreate.vue?vue&type=script&lang=js&"
export * from "./DomainCreate.vue?vue&type=script&lang=js&"
import style0 from "./DomainCreate.vue?vue&type=style&index=0&id=5cf9d81b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf9d81b",
  null
  
)

export default component.exports